export function arr_get($array, $key, $default) {
  $default = $default ?? null;

  if (typeof $array !== "object") {
    return $default;
  }

  if (typeof $key === "undefined" || $key === null) {
    return $array;
  }

  if (typeof $key !== "undefined" && typeof $array[$key] !== "undefined") {
    return $array[$key];
  }

  if ($key.indexOf(".") === -1) {
    return $array[$key] ?? $default;
  }

  var skip = false;
  $key.split(".").forEach(function ($segment) {
    if (skip) {
      return;
    }

    if (
      typeof $array === "object" &&
      typeof $array[$segment] !== "undefined" &&
      $array[$segment] !== null
    ) {
      $array = $array[$segment];
    } else {
      $array = $default;
      skip = true;
    }
  });

  return $array;
}

export function arr_set($array, $key, $value) {
  if (typeof $key === "undefined" || $key === null) {
    return ($array = $value);
  }

  if ($key.indexOf(".") === -1) {
    $array[$key] = $value;

    return $array;
  }

  let $keys = $key.split(".");
  $key = $keys.slice(0, 1).join(".");

  if (
    typeof $array[$key] === "undefined" ||
    typeof $array[$key] !== "object" ||
    $array[$key] === null ||
    typeof $array[$key] === Proxy
  ) {
    $array[$key] = new Object();
  }

  $array[$key] = arr_set($array[$key], $keys.slice(1).join("."), $value);

  return $array;
}

export let analytics = {
  selectItem: function (product) {
    ga4.ecommerce("select_item", { items: [ga4.templates.product(product)] });
    fathomService.event("Offer Clicked", {});
    if (product.withRealPhotos) {
      fathomService.event("Offer Clicked - With Real Photo", {});
    } else {
      fathomService.event("Offer Clicked - Without Real Photo", {});
    }
  },
};

export let fathomService = {
  event: function (event, value) {
    if (typeof window.fathom !== "undefined") {
      window.fathom.trackEvent(event, {
        _value: value,
      });
    }
  },
};

export let ga4 = {
  templates: {
    product: function (product, data) {
      return {
        ...{
          item_id: "",
          item_name: "",
          coupon: "",
          currency: "PLN",
          discount: "",
          index: 0,
          item_brand: "",
          item_category: "",
          item_category2: "",
          item_category3: "",
          item_category4: "",
          item_category5: "",
          item_list_id: "",
          item_list_name: window.location.pathname
            .substring(1)
            .replaceAll("/", "_"),
          item_variant: "",
          location_id: "",
          promotion_id: "",
          promotion_name: "",
          price: "",
          quantity: 1,
        },
        ...{
          item_id: product.natcode,
          item_name: product.name,
          discount: product.discount,
          item_brand: product.brand,
          item_category: product.productType,
          item_category2: product.clientType,
          item_category3: product.bodyType,
          item_category4: product.fuelType,
          item_category5: product.transmissionType,
          item_list_id: product.period,
          item_variant: product.natcode,
          price: product.installment,
        },
        ...data,
      };
    },
  },
  ecommerce: function (event, ecommerceData, data) {
    var dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      ...{
        event: event,
        ecommerce: ecommerceData,
      },
      ...data,
    });
  },
  event: function (event, data) {
    if (typeof gtag !== "undefined") {
      gtag("event", event, data);
    }
  },
};
